import Navbar from "./Navbar.js";
import Footer from "./Footer.js";
import theme from "./theme.js";
import { ThemeProvider, CssBaseline, Box } from "@mui/material";
import { Outlet } from "react-router";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          FontFace: "Montserrat",
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Navbar />
          <Outlet />
        </Box>
        <Footer />
      </Box>
    </ThemeProvider>
  );
}

export default App;
